<app-header [menuOpen]="menuOpen()" (menuToggle)="toggle()" />
<app-sidebar [open]="menuOpen()" />
@if (menuOpen()) {
    <button type="button" class="backdrop" (click)="close()" [attr.aria-label]="'shell.menu.close' | translate"></button>
}
<main>
    <router-outlet />
</main>
